import { render, staticRenderFns } from "./haib_config.vue?vue&type=template&id=2e8a7fe4&scoped=true&"
import script from "./haib_config.vue?vue&type=script&lang=js&"
export * from "./haib_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a7fe4",
  null
  
)

export default component.exports